import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  faChevronDown,
  faChevronUp,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useFetch from "../../../../hooks/useFetch";

const FoundHerPartners = () => {
  const authState = useSelector((state) => state.authReducer);
  const token = authState?.token;
  const [fetchData] = useFetch();
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);

  const loadPartners = async () => {
    try {
      setLoading(true);

      const response = await fetchData({
        url: "/foundher/partners",
        method: "GET",
        headers: { Authorization: token },
      });

      if (response.success) {
        setPartners(response.data || []);
        setLoaded(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => {
    const next = !open;

    setOpen(next);

    if (next && !loaded) {
      loadPartners();
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-5 py-4">
      <div className="bg-gradient-to-br from-violet-950/70 via-slate-900 to-pink-950/60 border border-violet-700 rounded-3xl overflow-hidden">
        <button
          onClick={handleToggle}
          className="w-full flex justify-between items-center px-6 py-4 hover:bg-white/5 transition"
        >
          <div className="text-left">
            <h2 className="text-2xl lg:text-3xl font-bold text-pink-300">
              🤝 Development Partners & Social Contributors
            </h2>

            <p className="mt-2 text-gray-300 text-sm lg:text-base max-w-4xl leading-relaxed">
              Our heartfelt gratitude to the corporates, banks, trusts, NGOs,
              institutions, philanthropists, influencers and ecosystem partners
              who believe in empowering young women entrepreneurs through
              opportunity, technology, guidance and collaboration.
            </p>
          </div>

          <FontAwesomeIcon
            icon={open ? faChevronUp : faChevronDown}
            className="text-2xl text-pink-300"
          />
        </button>

        {open && (
          <div className="border-t border-violet-700">
            <div className="flex justify-end px-5 py-2">
              <button
                onClick={loadPartners}
                className="text-pink-300 hover:text-white px-2 py-1 w-fit"
              >
                <FontAwesomeIcon icon={faRotateRight} /> Refresh
              </button>
            </div>

            {loading ? (
              <div className="text-center py-10 text-gray-300">Loading...</div>
            ) : ( 
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 px-6 py-2">
                {partners.map((partner) => {
                  const { imageCode, sponsorName, websiteLink } = partner;

                  return (
                    <a
                      key={imageCode}
                      href={websiteLink}
                      target="_blank"
                      rel="noreferrer"
                      className="group flex flex-col items-center text-center bg-zinc-700 p-2"
                    >
                      <img
                        src={`/api/downloads/foundher/partners/${imageCode}`}
                        alt={sponsorName}
                        className="w-12 h-12 rounded-full border-4 border-white object-cover"
                      />

                      <div className="mt-3 text-xs lg:text-sm text-pink-100 group-hover:text-white font-medium">
                        {sponsorName}
                      </div>
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default FoundHerPartners;
